// 12 Swipe-to-Discover cards
// Each card carries 6 DNA signals (matching TravelDNABoard dimensions) and 5 psychographic signals

const SWIPE_CARDS = [
  {
    id: 'temple-sunrise',
    title: 'Temple at Sunrise',
    subtitle: 'Golden light on ancient stones',
    image: 'https://images.unsplash.com/photo-1548013146-72479768bada?w=600&q=80',
    dna: { cultural: 20, adventure: 5, relaxation: 10, culinary: 0, nature: 10, luxury: 5 },
    psycho: { planning: 5, social: -5, pace: -5, comfort: 0, culture: 15 },
  },
  {
    id: 'street-food',
    title: 'Street Food Market',
    subtitle: 'Sizzling woks and spice clouds',
    image: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=600&q=80',
    dna: { cultural: 10, adventure: 10, relaxation: 0, culinary: 25, nature: 0, luxury: 0 },
    psycho: { planning: -5, social: 10, pace: 5, comfort: -10, culture: 10 },
  },
  {
    id: 'mountain-summit',
    title: 'Mountain Summit',
    subtitle: 'Above the clouds, on top of the world',
    image: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=600&q=80',
    dna: { cultural: 0, adventure: 25, relaxation: 5, culinary: 0, nature: 20, luxury: 0 },
    psycho: { planning: 10, social: -5, pace: 10, comfort: -15, culture: 5 },
  },
  {
    id: 'cozy-cafe',
    title: 'Cozy Cafe Corner',
    subtitle: 'Slow mornings, good coffee, people-watching',
    image: 'https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=600&q=80',
    dna: { cultural: 5, adventure: 0, relaxation: 20, culinary: 15, nature: 0, luxury: 10 },
    psycho: { planning: 0, social: 5, pace: -15, comfort: 10, culture: -5 },
  },
  {
    id: 'diving',
    title: 'Diving & Snorkeling',
    subtitle: 'Crystal waters and coral worlds',
    image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=600&q=80',
    dna: { cultural: 0, adventure: 25, relaxation: 5, culinary: 0, nature: 20, luxury: 5 },
    psycho: { planning: 5, social: 5, pace: 10, comfort: -5, culture: 5 },
  },
  {
    id: 'museum',
    title: 'Museum Interior',
    subtitle: 'Whispered history behind glass',
    image: 'https://images.unsplash.com/photo-1565060299509-1da9c47e3e16?w=600&q=80',
    dna: { cultural: 25, adventure: 0, relaxation: 10, culinary: 0, nature: 0, luxury: 10 },
    psycho: { planning: 10, social: -5, pace: -10, comfort: 10, culture: -5 },
  },
  {
    id: 'beach-hammock',
    title: 'Beach Hammock',
    subtitle: 'Swaying to the rhythm of waves',
    image: 'https://images.unsplash.com/photo-1519046904884-53103b34b206?w=600&q=80',
    dna: { cultural: 0, adventure: 0, relaxation: 25, culinary: 0, nature: 15, luxury: 10 },
    psycho: { planning: -10, social: -5, pace: -15, comfort: 15, culture: -10 },
  },
  {
    id: 'night-market',
    title: 'Night Market',
    subtitle: 'Lanterns, laughter, and late-night bites',
    image: 'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=600&q=80',
    dna: { cultural: 15, adventure: 10, relaxation: 0, culinary: 20, nature: 0, luxury: 0 },
    psycho: { planning: -5, social: 15, pace: 5, comfort: -5, culture: 10 },
  },
  {
    id: 'ancient-ruins',
    title: 'Ancient Ruins',
    subtitle: 'Walking where empires once stood',
    image: 'https://images.unsplash.com/photo-1603565816030-6b389eeb23cb?w=600&q=80',
    dna: { cultural: 25, adventure: 10, relaxation: 5, culinary: 0, nature: 5, luxury: 0 },
    psycho: { planning: 5, social: -10, pace: -5, comfort: -5, culture: 15 },
  },
  {
    id: 'cooking-class',
    title: 'Cooking Class',
    subtitle: 'Learn the secrets of local flavors',
    image: 'https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=600&q=80',
    dna: { cultural: 10, adventure: 5, relaxation: 5, culinary: 25, nature: 0, luxury: 5 },
    psycho: { planning: 10, social: 10, pace: -5, comfort: 5, culture: 5 },
  },
  {
    id: 'forest-hiking',
    title: 'Forest Hiking',
    subtitle: 'Moss-covered trails and birdsong',
    image: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=600&q=80',
    dna: { cultural: 0, adventure: 15, relaxation: 10, culinary: 0, nature: 25, luxury: 0 },
    psycho: { planning: 5, social: -10, pace: 5, comfort: -10, culture: 10 },
  },
  {
    id: 'rooftop-bar',
    title: 'Rooftop Bar',
    subtitle: 'City lights and craft cocktails',
    image: 'https://images.unsplash.com/photo-1470337458703-46ad1756a187?w=600&q=80',
    dna: { cultural: 5, adventure: 5, relaxation: 10, culinary: 10, nature: 0, luxury: 25 },
    psycho: { planning: 5, social: 15, pace: 0, comfort: 15, culture: -10 },
  },
];

export default SWIPE_CARDS;

/**
 * Compute DNA dimensions from liked cards.
 * Averages the dna signals of all liked cards, normalized to 0-100 per dimension.
 * @param {Array} likedCards — array of card objects that were swiped right
 * @returns {{ cultural: number, adventure: number, relaxation: number, culinary: number, nature: number, luxury: number }}
 */
export function computeDNAFromSwipes(likedCards) {
  if (!likedCards.length) {
    return { cultural: 50, adventure: 50, relaxation: 50, culinary: 50, nature: 50, luxury: 50 };
  }

  const totals = { cultural: 0, adventure: 0, relaxation: 0, culinary: 0, nature: 0, luxury: 0 };
  likedCards.forEach((card) => {
    Object.entries(card.dna).forEach(([key, val]) => {
      totals[key] += val;
    });
  });

  // Normalize: max possible per dimension is 25 * likedCards.length → scale to 0-100
  const maxPerDim = 25 * likedCards.length;
  const result = {};
  Object.entries(totals).forEach(([key, val]) => {
    result[key] = Math.round(Math.min(100, (val / maxPerDim) * 100));
  });

  return result;
}

/**
 * Compute psychographic profile from liked cards' psycho signals.
 * @param {Array} likedCards
 * @returns {{ planning: number, social: number, pace: number, comfort: number, culture: number }}
 */
export function computePsychoFromSwipes(likedCards) {
  const profile = { planning: 50, social: 50, pace: 50, comfort: 50, culture: 50 };
  if (!likedCards.length) return profile;

  likedCards.forEach((card) => {
    Object.entries(card.psycho).forEach(([key, delta]) => {
      profile[key] += delta;
    });
  });

  // Clamp to 0-100
  Object.keys(profile).forEach((key) => {
    profile[key] = Math.max(0, Math.min(100, Math.round(profile[key])));
  });

  return profile;
}
